const enumVariabls = {
    featureContentCat: {
        AUTOPILOT_FSD: "autopilot & FSD",
        BUYING_SELLING: "Buying & Selling",
        BATTERY_CHARGING: "Battery & Charging",
        CLIMATE: "climate",
        CONTROLS: "controls",
        EASTER_EGGS: "easter eggs",
        GENERAL:"general",
        NAVIGAION: "navigation",
        NEWS: "news",
        PHONE: "phone",
        RADIO_MEDIA: "radio & media",
        SERVICE: "service",
        SETTINGS: "settings",
        SOFTWARE_UPDATES: "software & updates",
        TESLA_APP: "tesla app",
        T3_PODCAST: "t3 podcast",
    }
}

export default enumVariabls